import MasterData from '@/js/services/contracts/MasterData';

const mapFieldToERP = (field) => {
  const DataComplementary = [];
  const codes = Object.keys(field.dcs);
  codes.forEach((code) => {
    DataComplementary.push({
      Code: code,
      Value: field.dcs[code],
    });
  });

  const fieldERP = {
    Id: field.id_external || 0,
    Code: field.code,
    Name: field.name,
    Surface: field.surface,
    Owner: field.farmer.code,
    OwnershipType: field.ownershipType,
    DataComplementary,
    GeoJson: (Object.keys(field.geoJSON).length > 0) ? field.geoJSON : null,
    Zone: field.Zone,
  };

  return fieldERP;
};

const mapERPFieldToLocal = async (fieldERP) => {
  const farmer = await MasterData.getByKey('farmers', 'code', fieldERP.Agricultor);
  if (farmer.length === 0) {
    return null;
  }
  const dcs = {};
  fieldERP.dcs.forEach((dc) => {
    dcs[dc.code] = dc.value;
  });
  const field = {
    id_external: fieldERP.Id,
    code: fieldERP.Codigo,
    name: fieldERP.Nombre,
    surface: fieldERP.SuperficieCultivable,
    farmer: farmer[0].id,
    farmers: farmer.map((objeto) => objeto.id),
    ownershipType: fieldERP.Id_RegimenTenencia,
    dcs,
    geoJSON: fieldERP.GeoJson,
    Zone: fieldERP.Id_Zona,
    sync_status: 0,

  };
  return field;
};

export { mapERPFieldToLocal, mapFieldToERP };
